<template>
	<select-image
		@select='getImageSource'
		output='file'
	/>
</template>

<script>
import SelectImg from "vue-select-img";
export default {
    components: {
        "select-image": SelectImg
    },
    methods: {
        getImageSource( source ) {
            const formData = new FormData( );
            formData.append( "file", source );
            const params = formData;
            this.$apis.uploadFileRequest( { params } ).then( res => {
                this.$emit( "success", res.fileUrl );
            } ).catch( console.log );
        }
    }
};
</script>

<style>

</style>
